export const CHeaderFindADoctorButton = {
  field: `
      fragment headerFindADoctorButton on headerFindADoctorButton_MatrixField {
        ... on headerFindADoctorButton_findADoctorCta_BlockType {
          id
          hideCta
        }
      }
    `,
}
